<template>
  <div class="base-label">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.base-label {
  border: 1px solid var(--primary);
  color: var(--primary);
  border-radius: 0.5rem;
  padding: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
</style>
